module.exports = __webpack_public_path__ + "media/common/images/medical-exam-icon-b5cd99e42483a61e9d760ffc46514fd9.svg";